import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/names/page.tsx");
